import React from "react";
import MainPanel from "../components/MainPanel";

function MainPanelContainer({ mainPanelStyle, ...restProps }) {
  return (
    <div
      className="main-panel main-panel-container-div"
      style={mainPanelStyle}
    >
      <MainPanel {...restProps} />
    </div>
  );
}

export default React.memo(MainPanelContainer);
